import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-germ',
  templateUrl: './svg-germ.component.html',
})
export class SvgGermComponent {
  constructor() {}
}
